import ButtonFill from '@components/ButtonFill';
import ErrorableField from '@components/Formik/ErrorableField';
import {EMAIL} from '@constants/subscription';
import type {FreeSubscription} from '@interfaces/Subscription';
import {Form, useFormikContext} from 'formik';
import type {ReactElement} from 'react';
import I18n from '@components/I18n';

interface Props {
    isBlock: boolean;
    isLargeButton: boolean;
}

export default function InnerForm({isBlock, isLargeButton}: Props): ReactElement<Props> {
    const formik = useFormikContext<FreeSubscription>();

    return (
        <Form className={isBlock ? 'subscribe-form--block' : 'subscribe-form'}>
            <div className="subscribe-form__body">
                <ErrorableField
                    type="text"
                    name={EMAIL}
                    placeholder="email"
                    className="subscribe-form__email"
                    withErrorMessage
                />
            </div>
            <div>
                {!formik.isSubmitting && (
                    <ButtonFill
                        type="submit"
                        className="subscribe-form__submit"
                        isLarge={isLargeButton}
                    >
                        <I18n code="SubscriptionForm_submit" />
                    </ButtonFill>
                )}
                {formik.isSubmitting ? (
                    <div className="subscribe-form__loading">
                        <div className="loading-spinner" />
                    </div>
                ) : null}
            </div>
        </Form>
    );
}
